import { XIcon } from "@heroicons/react/solid";

import { TabItem } from "../types";

import { Button } from "@/components/ui/button";
import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";

export const DynamicTab = ({ tab, actualIsActive }: { tab: TabItem; actualIsActive: boolean }) => (
  <span className="flex max-w-[180px] items-center gap-2">
    <span className="relative max-h-4 min-h-4 min-w-4 max-w-4">
      <span
        className={`absolute inset-0 text-blue-400 transition-opacity duration-300 ${
          actualIsActive ? "opacity-100" : "opacity-0"
        }`}
      >
        {tab.solidIcon}
      </span>
      <span
        className={`absolute inset-0 text-gray-400 transition-opacity duration-300 ${
          actualIsActive ? "opacity-0" : "opacity-100"
        }`}
      >
        {tab.outlineIcon}
      </span>
    </span>
    <OverflowDisplayTooltip content={tab.name}>
      <span className="truncate">{tab.name}</span>
    </OverflowDisplayTooltip>
    {tab.onClose && (
      <Button
        variant="ghost"
        size="icon"
        className="!p-0 transition-all duration-100 ease-in-out hover:bg-transparent hover:text-red-500"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          tab.onClose?.(tab.id);
        }}
      >
        <XIcon className="h-3.5 w-3.5" />
      </Button>
    )}
  </span>
);
